// extracted by css-extract-rspack-plugin
export default {"root":"root-W-IK7","number":"number-1dK1K","message":"message-2eweu"};